export default __webpack_public_path__ + "static/media/6-sgi-matricula-v2-01.png:Zone.0543b9e3.Identifier";